import { relativeUrl, escapeAll } from './relativeUrl';

export const markedConfig = ['markedProvider', 'configurationServiceProvider', 'currentApplicationServiceProvider',
    (markedProvider, configurationServiceProvider, currentApplicationServiceProvider) => {
        const service = currentApplicationServiceProvider.$get();
        configurationServiceProvider.$get()
            .getConfiguration()
            .then(data => {
                markedProvider.setRenderer({
                    image: (href: string, title: string, text: string) => {
                        const src = relativeUrl(href, data.apiUrl, service.getApplicationConfiguration().guid);
                        return `<img src="${src}" alt="${escapeAll(text)}" title="${title ? escapeAll(title) : src}" />`;
                    },
                    link: (href: string, title: string, text: string) => {
                        const src = relativeUrl(href, data.apiUrl, service.getApplicationConfiguration().guid);
                        return `<a href='${src}' title='${title ? escapeAll(title) : src}' target='_blank'>${escapeAll(text)}</a>`;
                    }
                });
            })
            .catch(reason => {
                console.error('Unable to initialize markdown renderer.');
                console.error(reason);
            });
        markedProvider.setOptions({
            gfm: true,
            tables: true
        });
    }];